import React, { useState, useEffect } from 'react';
import gsap from 'gsap';

// Imágenes para el vaso
import vasoTop from '../assets/sliders/VasoCerveceroVacio_BordeRojo.png';
//Sticker Vaso Slider
import vasoRBDHuge from '../assets/sliders/VasoRBD.jpg';
import vasoMoanaHuge from '../assets/sliders/VasoRBD.jpg';
import vasoBaseballHuge from '../assets/sliders/VasoRBD.jpg';

function AnimacionVasos({ imageSrc, altText = "Imagen Stick" }) {
    /*useEffect(() => {
        const vasoMoveLanding = document.getElementById("vaso-move-landing");
        if (!vasoMoveLanding) return;
    
        const maskImgLanding = vasoMoveLanding.querySelector(".mask1 img");
    
        if (maskImgLanding) {
          const tlImgLanding = gsap.timeline({ repeat: -1, yoyo: false });
          tlImgLanding
            .to(maskImgLanding, {
              x: 80,
              y: 28,
              scale: 1.65,
              rotate: -3,
              duration: 2,
              delay: 1,
              ease: "power2.out",
            })
            .to(maskImgLanding, {
              x: 0,
              y: 38,
              scale: 1.65,
              rotate: 0,
              duration: 2,
              ease: "power2.out",
            })
            .to(maskImgLanding, {
              x: -80,
              y: 28,
              scale: 1.65,
              rotate: 3,
              duration: 2,
              ease: "power2.out",
            })
            .to(maskImgLanding, {
              x: 0,
              y: 38,
              scale: 1.65,
              rotate: 0,
              duration: 2,
              ease: "power2.out",
            });
        }
    
        


      }, []);*/
      /*const tlVaso = gsap.timeline({ repeat: -1, yoyo: false });
        tlVaso
          .to(vasoMove, {
            x: 400,
            rotate: 16,
            duration: 2,
            delay: 1,
            ease: "power2.out",
          })
          .to(vasoMove, {
            x: 0,
            rotate: 0,
            duration: 2,
            ease: "power2.out",
          })
          .to(vasoMove, {
            x: -400,
            rotate: -16,
            duration: 2,
            ease: "power2.out",
          })
          .to(vasoMove, {
            x: 0,
            rotate: 0,
            duration: 2,
            ease: "power2.out",
          });*/
  return (
    <>
      <div id="vaso-landing" className="wrap">
      {/*position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%) scale(1.5)', width:'360px', height:'445px', zIndex:'10'*/}
        <div id="vaso-move-landing" >
          <div className="mask1-landing">
            {/*Recuerda sustituir por variables SRC y ALT*/}
            {/*<img className='langing-huge fade-target' src={vasoRBDHuge} alt="Imagen Stick"/>*/}
            <img className="langing-huge fade-target" src={imageSrc} alt={altText} />
          </div>
          <img className='vaso-top-landing' src={vasoTop} alt="Vaso top" />
        </div>
    </div>
    </>
  )
}

export default AnimacionVasos